import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=5537657b&scoped=true&"
import script from "./_category.vue?vue&type=script&lang=js&"
export * from "./_category.vue?vue&type=script&lang=js&"
import style0 from "./_category.vue?vue&type=style&index=0&id=5537657b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5537657b",
  null
  
)

export default component.exports